import emitter from './emitter'
export const Soda = window.Soda || {
  merchant: {},
}

export class BridgeMonitor {
  constructor(module, method) {
    this.fnList = []
    Soda[module][method] = (...args) => {
      emitter.emit(`${module}.${method}`, ...args)
    }

    emitter.on(`${module}.${method}`, (...res) => {
      this.fnList.forEach(fn => {
        fn(...res)
      })
    })
  }

  register(fn) {
    this.fnList.push(fn)
  }

  unregister(fn) {
    const index = this.fnList.indexOf(fn)
    if (index !== -1) {
      this.fnList.splice(index, 1)
    }
  }
}
